'use client'

export const dynamic = 'force-dynamic'

import { AuthForm } from '../AuthForm'

export default function SignupPage() {
  return <AuthForm initialMode="signup" />
}
